import React, { Suspense, useState } from 'react'
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom'

import NotFound from './pages/not-found/notFound'
import LoginValidation from './LoginValidation'
import Login from './pages/login/login'
import Home from './pages/home/home'
import logo_small from './images/logo_small.png'

import './fonts/Gotham/Gotham-Bold.otf'
import './App.scss'

const App = () => {
  const goToHome = () => (window.location.href = '/home')
  const loadingScreen = <span className="loading">Loading</span>

  return (
    <>
      <Router>
        <Switch>
          <Route path="/signin">
            <Suspense fallback={loadingScreen}>
              <Login />
            </Suspense>
          </Route>
          <Route path="/home">
            <Suspense fallback={loadingScreen}>
              <LoginValidation>
                <Home />
              </LoginValidation>
            </Suspense>
          </Route>
          <Route path="/">
            <Suspense fallback={loadingScreen}>
              <LoginValidation>
                <NotFound />
              </LoginValidation>
            </Suspense>
          </Route>
        </Switch>
      </Router>
    </>
  )
}
export default App
